import React from 'react';
import {KTIcon} from "../../../../_metronic/helpers";

function BackBtn(props) {
    const {className,label,...rest} =props
    return (
        <button type={'button'} className={`btn btn-sm btn-light-primary ${className}`}
                {...rest}>
            {label??'بازگشت'}
            <KTIcon iconName={'black-left'} className={'fs-2'}/>
        </button>
    );
}

export default BackBtn;